import { calculateCanvasImageDimensions } from "client/utils/calculateCanvasImageDimensions";
import { Icon as IconType } from "types/meme";
import { ToolTip } from "components/common/ToolTip/ToolTip";

interface IconProps {
    icon: IconType;
    handleClick: (icon: IconType) => void;
}

export function Icon({ icon, handleClick }: IconProps) {
    const { width, height } = calculateCanvasImageDimensions(icon.settings.width, icon.settings.height, 60, 60, false);
    return (
        <ToolTip text={icon.title}>
            <button
                className={`cursor-pointer w-[60px] h-[60px]
                    bg-[rgba(110,_153,_244,_0.08)] dark:bg-darkSurface-300 hover:bg-irBlue-100 focus:bg-[rgba(110,_153,_244,_0.08)] 
                    p-2 rounded-lg flex items-center justify-center`}
                aria-label={`Select ${icon.title} icon`}
                onClick={() => handleClick(icon)}
            >
                <img
                    src={icon.src}
                    style={{
                        width,
                        height,
                    }}
                    alt={icon.title}
                />
            </button>
        </ToolTip>
    );
}
